var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFounderFinanceInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 13,
    y1: 9,
    x2: 67,
    y2: 71
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE2D0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 4,
    y: 6,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 9,
    floodColor: "#4B3420",
    floodOpacity: 0.08
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 54,
    height: 54,
    rx: 20,
    fill: "url(#bg)",
    filter: "url(#d)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 50V39",
    stroke: "#8B642C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 50V31",
    stroke: "#8B642C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50V35",
    stroke: "#8B642C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 51H46",
    stroke: "#073F37",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 29.5 58 33.8V42.3L50.5 46.6 43 42.3V33.8L50.5 29.5Z",
    stroke: "#073F37",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 33.9 50.5 38.1 57.8 33.9",
    stroke: "#073F37",
    strokeWidth: 2.4,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 38.1V46.4",
    stroke: "#073F37",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFounderFinanceInventory);
export default __webpack_public_path__ + "static/media/founder-finance-inventory.3995a5534a7c32b3b2dd41ae3445e11b.svg";
export { ForwardRef as ReactComponent };